module.exports = __webpack_public_path__ + "media/11.0d73d4a1.mp3";